import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Users from '@/components/Users'
import SearchRides from '@/components/SearchRides'
import Rides from '@/components/Rides'
import Drivers from '@/components/Drivers'
import SearchDrivers from '@/components/SearchDrivers'
import SearchRequestLogs from '@/components/SearchRequestLogs'
import RequestLogs from '@/components/RequestLogs'
import CurrentRides from '@/components/CurrentRides'
import WillCallRides from '@/components/WillCallRides'

import Settings from '@/components/Settings'
import CreateRide from '@/components/CreateRide'
import CreateDriver from '@/components/CreateDriver'
import CreateVehicle from '@/components/CreateVehicle'
import Login from '@/components/Login'
import AssignRides from '@/components/AssignRides'
import UpdateDriver from '@/components/UpdateDriver'
import DriverPayments from '@/components/DriverPayments'
import DriverDashboard from '@/components/DriverDashboard'
import ResetPassword from '@/components/ResetPassword'
import SendResetLink from '@/components/SendResetLink'
import Reports from '@/components/Reports'
import PaymentAdjustments from '@/components/PaymentAdjustments'
import MissingSignatures from '@/components/MissingSignatures'
import PendingPayments from '@/components/PendingPayments'
import DriversMap from '@/components/DriversMap'
import ReportEmergency from '@/components/ReportEmergency'
import ClaimsProcessing from '@/components/ClaimsProcessing'
import BookingOrganizations from '@/components/BookingOrganizations'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/current-rides/',
      name: 'CurrentRides',
      component: CurrentRides
    },
    {
      path: '/will-call-rides/',
      name: 'WillCallRides',
      component: WillCallRides
    },    
    {
      path: '/search-rides/',
      name: 'SearchRides',
      component: SearchRides
    },
    {
      path: '/rides/:id_ride/',
      name: 'Rides',
      component: Rides
    },
    {
      path: '/search-drivers/',
      name: 'SearchDrivers',
      component: SearchDrivers,
    },
    {
      path: '/drivers/:id_driver/',
      name: 'Drivers',
      component: Drivers
    },
    {
      path: '/settings/',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/send-reset-link/',
      name: 'SendResetLink',
      component: SendResetLink,
      meta: {
        guest: true
      }
    },
    {
      path: '/reset/:id_user/:code/',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        guest: true
      }
    },
    {
      path: '/users/:id_user/',
      name: 'Users',
      component: Users
    },
    {
      path: '/create-a-ride/',
      name: 'CreateRide',
      component: CreateRide
    },
    {
      path: '/create-a-driver/',
      name: 'CreateDriver',
      component: CreateDriver
    },
    {
      path: '/create-a-vehicle/',
      name: 'CreateVehicle',
      component: CreateVehicle
    },
    {
      path: '/assign-rides/',
      name: 'AssignRides',
      component: AssignRides
    },
    {
      path: '/update-driver/:id_driver/',
      name: 'UpdateDriver',
      component: UpdateDriver
    },
    {
      path: '/driver-payments/',
      name: 'DriverPayments',
      component: DriverPayments
    },
    {
      path: '/driver-dashboard/:id_driver/',
      name: 'DriverDashboard',
      component: DriverDashboard
    },
    {
      path: '/reports/',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/payment-adjustments/',
      name: 'PaymentAdjustments',
      component: PaymentAdjustments
    },
    {
      path: '/missing-signatures/',
      name: 'MissingSignatures',
      component: MissingSignatures
    },    
    {
      path: '/pending-payments/',
      name: 'PendingPayments',
      component: PendingPayments
    },
    {
      path: '/request-logs/:id/',
      name: 'RequestLogs',
      component: RequestLogs
    },
    {
      path: '/request-logs/',
      name: 'SearchRequestLogs',
      component: SearchRequestLogs
    },
    {
      path: '/drivers-map/',
      name: 'DriversMap',
      component: DriversMap
    },
    {
      path: '/report-emergency/',
      name: 'ReportEmergency',
      component: ReportEmergency
    },
    {
      path: '/claims-processing/',
      name: 'ClaimsProcessing',
      component: ClaimsProcessing
    },
    {
      path: '/booking-organizations/',
      name: 'BookingOrganizations',
      component: BookingOrganizations
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js